import { Checkbox, ListItem } from '@coolblue-development/freddy';
import { getDisplayName } from '@features/filter/components/Filters/helpers/getDisplayName';
import { memo } from 'react';

import { FacetValue } from '../../../../types';
import { FacetDescription } from '../FacetDescription';

const FacetValueItem = memo(function FacetValueItem({
  value,
  recommendedFacetValue
}: {
  value: FacetValue;
  recommendedFacetValue: string;
}) {
  const isRecommended = value.reference === recommendedFacetValue;

  return (
    <ListItem key={value.displayName}>
      <Checkbox
        label={getDisplayName(value.displayName, value.name)}
        value={value.value}
        description={<FacetDescription count={value.count} isRecommended={isRecommended} />}
      />
    </ListItem>
  );
});

const buildFacetValues = (values: FacetValue[], recommendedFacetValue: string) =>
  values.map(value => (
    <FacetValueItem
      key={value.displayName}
      value={value}
      recommendedFacetValue={recommendedFacetValue}
    />
  ));

export default buildFacetValues;
